import { ZustandSupportStore } from './types';

export const isInitChatSelector = (state: ZustandSupportStore) =>
  state.isInitChat;

// ============================== Actions

export const setSupportChatStateAction = (state: ZustandSupportStore) =>
  state.setInitChatState;
